import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Box,
  Dialog,
  DialogContent,
} from "@mui/material";
import axios from "axios";
import Layout from "../../../layout/Layout";
import { useNavigate } from "react-router-dom";
import { payslipDetailsAPI, manageCompaniesAPI } from "../../../config";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";
import AddIcon from "@mui/icons-material/Add";
import { MaterialReactTable } from "material-react-table";
import EditLocationOutlinedIcon from "@mui/icons-material/EditLocationOutlined";
import IconButton from "@mui/material/IconButton";
import { AlertMessage } from "../../../components/AlertMessage";
import { useParams } from "react-router-dom";

function ManageAllowances() {
  const { id } = useParams();
  const company_id = Number(id);
  const navigate = useNavigate();
  const tempRefs = useRef(false);
  const childRef = useRef();
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up("lg"));

  const [allowancesList, setAllowancesList] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState([]);
  const [sorting, setSorting] = useState([]);

  // Fetch company options for the filter

  // Fetch allowances data
  const fetchAllowances = async () => {
    setLoading(true);
    try {
      const data = {
        intType: 2, // Assuming 2 is for fetching all allowances
        intOffset: pageIndex * pageSize,
        intLimit: pageSize,
        txtCompanyName: Number(company_id || 0),
      };

      const config = {
        method: "POST",
        data: JSON.stringify(data),
        url: payslipDetailsAPI,
        headers: {
          "Content-Type": "application/json",
        },
      };

      const response = await axios(config);
      setAllowancesList(response.data.result || []);
      setTotalCount(
        response.data.totalCount || response.data.result?.length || 0
      );
    } catch (error) {
      console.error("Error fetching allowances:", error);
      childRef.current.triggerAlert(
        JSON.stringify({
          message: "Failed to load allowances data",
          messageType: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllowances();
  }, [pageIndex, pageSize]);

  const columns = [
    {
      accessorKey: "company_name",
      header: "Company Name",
      enableSorting: false,
      size: 150,
      Cell: ({ cell }) => `${cell.getValue() || 0}`,
    },
    {
      accessorKey: "dearness_allowance",
      header: "Dearness Allowance(%)",
      enableSorting: false,
      size: 150,
      Cell: ({ cell }) => `${cell.getValue() || 0}`,
    },
    {
      accessorKey: "house_rent_allowance",
      header: "House Rent Allowance(%)",
      enableSorting: false,
      size: 150,
      Cell: ({ cell }) => `${cell.getValue() || 0}`,
    },
    {
      accessorKey: "vehicle_allowance",
      header: "Vehicle Allowance(Rupees)",
      enableSorting: false,
      size: 150,
      Cell: ({ cell }) => `${cell.getValue() || 0}`,
    },
    {
      accessorKey: "medical_allowance",
      header: "Medical Allowance(%)",
      enableSorting: false,
      size: 150,
      Cell: ({ cell }) => `${cell.getValue() || 0}`,
    },
    {
      accessorKey: "other_allowance",
      header: "Other Allowance(%)",
      enableSorting: false,
      size: 150,
      Cell: ({ cell }) => `${cell.getValue() || 0}`,
    },
    {
      accessorKey: "esi_percentage",
      header: "ESI Percentage(%)",
      enableSorting: false,
      size: 150,
      Cell: ({ cell }) => `${cell.getValue() || 0}`,
    },
    {
      accessorKey: "rd_percentage",
      header: "RD Percentage(%)",
      enableSorting: false,
      size: 150,
      Cell: ({ cell }) => `${cell.getValue() || 0}`,
    },
    {
      accessorKey: "created_at",
      header: "Created At",
      enableSorting: false,
      size: 150,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        if (!value) return "-";
        const date = new Date(value);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      accessorKey: "id",
      header: "Action",
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <IconButton
          color="warning"
          onClick={() => navigate(`/manage-allowances-add/${row.original.id}`)}
        >
          <EditLocationOutlinedIcon />
        </IconButton>
      ),
      size: 80,
    },
  ];

  return (
    <Layout>
      <AlertMessage ref={childRef} />
      <Grid className="employee-form">
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Manage Allowances List
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">Manage Allowances</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid
            textAlign="right"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <LoadingButton
              size="medium"
              variant="contained"
              color="success"
              href="/manage-allowances-add"
              startIcon={<AddIcon />}
              sx={{ mr: 2 }}
            >
              Add
            </LoadingButton>
            <LoadingButton
              size="medium"
              variant="contained"
              color="primary"
              onClick={() => navigate(-1)}
              startIcon={<ArrowBackIosIcon />}
            >
              Back
            </LoadingButton>
          </Grid>
        </Grid>

        <Box sx={{ mt: 3 }}>
          <MaterialReactTable
            columns={columns}
            data={allowancesList}
            enableGlobalFilter={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            enableDensityToggle={false}
            state={{
              isLoading: loading,
              pagination: { pageIndex, pageSize },
              // sorting,
              // columnFilters: filters,
            }}
            manualPagination
            initialState={{
              columnPinning: lgUp ? { right: ["created_at", "id"] } : {},
            }}
            // manualSorting
            // manualFiltering
            rowCount={totalCount}
            onPaginationChange={(updater) => {
              const { pageIndex: newPageIndex, pageSize: newPageSize } =
                updater({
                  pageIndex,
                  pageSize,
                });
              setPageIndex(newPageIndex);
              setPageSize(newPageSize);
            }}
            // onSortingChange={setSorting}
            // onColumnFiltersChange={setFilters}
            muiTableContainerProps={{
              sx: {
                maxHeight: "calc(100vh - 300px)",
              },
            }}
            muiTableBodyCellProps={{
              sx: {
                padding: "8px 16px",
                border: "1px solid #e0e0e0",
              },
            }}
            muiTableHeadCellProps={{
              sx: {
                "& input": {
                  color: "#fff !important",
                  "&::placeholder": {
                    color: "#fff !important",
                    opacity: 1,
                  },
                },
                "& .MuiSelect-select": {
                  color: "#fff !important", // selected text color
                },
                "& .MuiSelect-icon": {
                  color: "#fff !important", // dropdown arrow color
                },
                color: "#fff",
                fontWeight: "bold",
                "& svg": {
                  color: "#fff",
                },
                "& .MuiTableSortLabel-root": {
                  color: "#495057",
                  "&.Mui-active": {
                    color: "#fff",
                    "& .MuiTableSortLabel-icon": {
                      color: "#fff !important",
                    },
                  },
                },
                "& .MuiTableSortLabel-icon": {
                  color: "#fff !important",
                },
              },
            }}
            muiTableBodyRowProps={({ row }) => ({
              sx: {
                backgroundColor: row.index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                "&:hover": {
                  backgroundColor: "#e3f2fd",
                },
              },
            })}
          />
        </Box>
      </Grid>
    </Layout>
  );
}

export default ManageAllowances;
